export default "__VITE_ASSET__CCi$9W2L__"